import {CardElement, PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js'
import {FC, useEffect, useImperativeHandle} from "react";
import {useFormikContext} from "formik";
import {getStripeIntent} from "../../../../app/pages/balance/core/_requests";

interface StripePaymentFormProps {
  formik: any
  innerRef: any
  setSubmitted: (val: boolean) => void
}

const StripePaymentForm: FC<StripePaymentFormProps> = (
  {formik, innerRef, setSubmitted}
) => {
  const stripe = useStripe()
  const elements = useElements()
  const {setStatus, setFieldValue, values} = formik

  // Expose a function that parent components can call
  useImperativeHandle(
    innerRef,
    () => ({
      async processPayment() {
        if (!stripe || !elements) {
          // Stripe.js hasn't loaded yet
          return;
        }

        const amount = parseFloat(values.sum);
        setStatus(null);

        // Trigger form validation and wallet collection
        const {error: submitError} = await elements.submit();
        if (submitError) {
          setStatus(submitError);
          return;
        }

        try {
          // Create PaymentIntent on your server
          const response = await getStripeIntent(amount);

          const { clientSecret, error: backendError } = response;

          setFieldValue('payment_token', clientSecret);
          if (backendError) {
            setStatus(backendError);
            formik.setSubmitting(false)
            return;
          }

          // Confirm the payment
          const { error: stripeError } = await stripe.confirmPayment({
            elements,
            clientSecret,
            confirmParams: {
              return_url: `${window.location.origin}/balance/payment-success`,
            },
            redirect: 'if_required'
          });

          if (stripeError) {
            setStatus(stripeError.message);
            formik.setSubmitting(false)
          }else{
            setSubmitted(true);
            formik.setSubmitting(false)
          }
          // If successful, Stripe will handle the redirect

        } catch (err) {
          setStatus('An unexpected error occurred.');
          formik.setSubmitting(false)
          console.error(err);
        }

      }
    }),
    [stripe, elements, setSubmitted, values.sum]
  )

  useEffect(() => {
    const newAmount = parseFloat(values.sum);
    if (elements && newAmount>0) {
      elements.update({ amount: Math.round(newAmount * 100) });
    }
  }, [values.sum]);

  return (
    <div className="stripe-payment-form">
      <div className="row my-3">
        <div className="col-lg-12">
          <PaymentElement
            options={{
              wallets: {
                link: 'never'
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StripePaymentForm
